import { Checkbox } from '@carbon/react';
import { useAtom } from 'jotai';
import { scopedMapLayersAtom } from './atoms';
import type { ScopedMapLayers } from './types';
import styles from './scoped-layer-toggles.module.scss';

/** The toggle rows, in display order, mapping each layer key to its label. */
const LAYER_TOGGLES: { key: keyof ScopedMapLayers; label: string }[] = [
  { key: 'slots', label: 'Slots' },
  { key: 'tracts', label: 'Tracts' },
  { key: 'units', label: 'Units' },
  { key: 'ltd', label: 'LTD Slots' },
];

/**
 * Visibility toggles for the package-scoped map layers, slotted into the
 * map layers panel's "Scoped" section (via `<Map>`'s `scopedLayers` prop). Each
 * checkbox drives one key of `scopedMapLayersAtom`, which the Slot/Tract/Unit
 * layers read to show/hide themselves. Mirrors the General-section checkbox pattern in
 * `map-layers-selector.tsx`.
 *
 * @return {JSX.Element} The scoped-layer visibility checkboxes.
 */
export function ScopedMapLayerToggles() {
  const [scopedLayers, setScopedLayers] = useAtom(scopedMapLayersAtom);

  return (
    <div className={styles.toggles}>
      {LAYER_TOGGLES.map(({ key, label }) => (
        // Per-layer wrapper class drives the colored swatch (see the module scss).
        <div key={key} className={styles[key]}>
          <Checkbox
            id={`eval3-scoped-${key}`}
            labelText={label}
            checked={scopedLayers[key]}
            onChange={(_evt, { checked }: { checked: boolean }) =>
              setScopedLayers((current) => ({ ...current, [key]: checked }))
            }
          />
        </div>
      ))}
    </div>
  );
}
